/**
 * 404.
 *
 * From the kit: "Passy with his eyes closed. Grey band." That is the `idle`
 * state — nothing is running, because there is nothing here. It is the one
 * place on the site where the band is not green, and that is the whole joke.
 *
 * The <Seo> call sends `noindex`, which is what keeps a mistyped URL out of
 * search results. The server answers 200 for this page because a single-page
 * app has no route table to know better; the meta tag is what makes the
 * distinction to a crawler.
 */
import { Link } from 'react-router-dom';

import { Passy } from '../components/Passy';
import { Seo } from '../components/Seo';
import { useI18n } from '../i18n';
import { COMPANY } from '../lib/constants';
import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  const { t, localePath } = useI18n();

  return (
    <>
      <Seo title={`404 — ${COMPANY.tradeName}`} description={t.notFound.body} path="/404" noindex />

      <section className={styles.page}>
        <div className="container">
          <div className={styles.inner}>
            <Passy state="idle" size={72} label={null} />

            <p className="overline">404 · {t.notFound.eyebrow}</p>
            <h1 className={styles.title}>{t.notFound.title}</h1>
            <p className={styles.body}>{t.notFound.body}</p>

            <div className={styles.actions}>
              <Link className={styles.primary} to={localePath('/')}>
                {t.notFound.home}
              </Link>
              <a className={styles.secondary} href={`mailto:${COMPANY.email}`}>
                {t.notFound.contact}
              </a>
            </div>

            <p className={`meta ${styles.status}`}>{t.notFound.status}</p>
          </div>
        </div>
      </section>
    </>
  );
}
